import React, {useEffect, useState} from "react";
import {Button, Empty, Skeleton} from "antd";
import {useNavigate, useSearchParams} from "react-router-dom";
import {ActionKeys, SubjectName} from "../../../custom/permission/Ability";
import {AbilityUtil} from "../../../custom/permission/Can";
import {useMainLayoutContext} from "../../../layoutv2";
import {onChangeVisibleModal} from "../../../redux/actions/layout/interaction/action";
import {useDispatch} from "react-redux";
import PropTypes from "prop-types";
import {t} from "i18next";

function Nodata({loading, tabKey}) {
    const [action, setAction] = useState(null);
    const navigate = useNavigate();
    const {siderData} = useMainLayoutContext();
    const dispatch = useDispatch();
    const [create, setCreate] = useState(false);
    const [searchParams] = useSearchParams();
    const [content, setContent] = useState({
        title: t("common.empty.record"),
        message: t("common.empty.record"),
        navigate: window.location.pathname,
    });

    useEffect(() => {
        const debounce = setTimeout(() => {
            const currentAction = siderData?.filter((item) =>
                window.location.pathname?.includes(item?.key)
            );
            if (currentAction?.length > 0) {
                setAction(currentAction[0]);
            } else {
                setAction(null);
            }
        }, 100);

        return () => {
            clearTimeout(debounce);
        };
    }, [siderData]);

    useEffect(() => {

        let createValue = false;

        if (window.location.pathname?.includes("/wage/")) {
            createValue = AbilityUtil.allow(ActionKeys.CREATE, SubjectName.salaryTable, {})
        } else if (window.location.pathname?.includes("/setting")) {
            createValue = AbilityUtil.allow(ActionKeys.SETTING, SubjectName.timeKeeping, {})
        } else {
            createValue = AbilityUtil.allow(ActionKeys.CREATE, SubjectName.timeKeeping, {})
        }

        switch (window.location.pathname) {
            case "/hrm/timekeeping/time-sheet/timesheet":
                if (searchParams.get("view-shift-work")) {
                    setContent({
                        title: t("common.empty.shiftWork"),
                        message: t("common.empty.shiftWork"),
                        navigate:
                            "/hrm/timekeeping/time-sheet/shift-assignment/add",
                    });
                    setCreate(createValue);
                    break;
                } else {
                    setContent({
                        title: t("common.empty.timekeeping"),
                        message: t("common.empty.timekeeping"),
                    });
                    break;
                }

            case "/hrm/timekeeping/time-sheet/shift-assignment":
                setContent({
                    title: t("common.empty.shiftAssignment"),
                    message: t("common.empty.shiftAssignment"),
                    navigate:
                        "/hrm/timekeeping/time-sheet/shift-assignment/add",
                });
                if (tabKey && tabKey !== "all") {
                    setCreate(false);
                    break;
                }
                setCreate(createValue);
                break;

            case "/hrm/timekeeping/time-sheet/auto-check-in-out":
                setContent({
                    title: t("common.empty.autoTimeKeeping"),
                    message: t("common.empty.autoTimeKeeping"),
                    navigate: "/hrm/timekeeping/time-sheet/auto-check-in-out",
                });
                setCreate(createValue);
                break;
            case "/hrm/timekeeping/casual-and-compensatory/casual-leave":
                setContent({
                    title: t("common.empty.leave"),
                    message: t("common.empty.leave"),
                });
                break;
            case "/hrm/timekeeping/wage/table":
                setContent({
                    title: t("common.empty.payroll"),
                    message: t("common.empty.payroll"),
                    navigate: "/hrm/timekeeping/wage/table/manual-add",
                });
                setCreate(createValue);
                break;
            case "/hrm/timekeeping/wage/template":
                setContent({
                    title: t("common.empty.payrollConfig"),
                    message: t("common.empty.payrollConfig"),
                    navigate: "/hrm/timekeeping/wage/template/add",
                });
                setCreate(createValue);
                break;
            case "/hrm/timekeeping/wage/custom":
                setContent({
                    title: t("common.empty.payrollCustom"),
                    message: t("common.empty.payrollCustom"),
                    navigate: "/hrm/timekeeping/wage/custom",
                });
                setCreate(createValue);
                break;
            case "/setting/timekeeping/shift-work":
                setContent({
                    title: t("common.empty.shiftConfig"),
                    message: t("common.empty.shiftConfig"),
                    navigate: "/setting/timekeeping/shift-work/add",
                });
                setCreate(createValue);
                break;
            case "/setting/timekeeping/annual-leave":
                setContent({
                    title: t("common.empty.leaveConfig"),
                    message: t("common.empty.leaveConfig"),
                    navigate: "/setting/timekeeping/annual-leave/add",
                });
                setCreate(createValue);
                break;
            case "/setting/timekeeping/attendance-locations":
                setContent({
                    title: t("common.empty.locationCheckIn"),
                    message: t("common.empty.locationCheckIn"),
                    navigate: "/setting/timekeeping/attendance-locations/add",
                });
                setCreate(createValue);
                break;
        }
    }, [window.location.pathname, tabKey]);

    function onClickCreate() {
        if (
            window.location.pathname === "/hrm/timekeeping/time-sheet/auto-check-in-out" ||
            window.location.pathname === "/hrm/timekeeping/wage/custom") {
            dispatch(onChangeVisibleModal(true));
        }
        navigate(content.navigate);
    }

    return (
        <>
            {loading ? (
                <div
                    className={
                        "custom-table relative  bg-white rounded-bl-[12px] rounded-br-[12px] overflow-hidden"
                    }
                    style={{
                        borderRight: "1px solid #EAECF0",
                        borderLeft: "1px solid #EAECF0",
                        borderBottom: "1px solid #EAECF0",
                        height: "93%",
                    }}
                >
                    <Skeleton
                        className={'p-4'}
                        loading={loading}
                        active={true}
                    />
                </div>
            ) : (
                <div
                    className={`bg-white rounded-bl-[12px] rounded-br-[12px] overflow-hidden h-[92%] flex justify-center`}
                    style={{
                        borderRight: "1px solid #EAECF0",
                        borderLeft: "1px solid #EAECF0",
                        borderBottom: "1px solid #EAECF0",
                    }}
                >
                    <div className={"text-center mt-32"}>
                        <Empty
                            description={
                                <>
                                    <p
                                        className={
                                            "font-bold leading-7 text-lg"
                                        }
                                    >
                                        {t("tnp.components.salary.text174")}
                                    </p>
                                    <span className={"leading-6"}>
                                        {/*Hiện tại không có {content.title} nào.{" "}*/}
                                        {t("common.empty.notFoundRecord",{module : content.title})}
                                        {create ? t("common.empty.click") : null}{" "}
                                    </span>
                                    {create && (
                                        <Button
                                            type="link"
                                            onClick={onClickCreate}
                                            style={{
                                                paddingLeft: 0,
                                                color: AbilityUtil.allow(
                                                    ActionKeys.CREATE,
                                                    action?.name ||
                                                    action?.subjectName ||
                                                    SubjectName.timeKeeping,
                                                    {}
                                                )
                                                    ? "var(--primary-color)"
                                                    : "#98A2B3",
                                                fontWeight: "bold",
                                                cursor: AbilityUtil.allow(
                                                    ActionKeys.CREATE,
                                                    action?.name ||
                                                    action?.subjectName ||
                                                    SubjectName.timeKeeping,
                                                    {}
                                                )
                                                    ? "pointer"
                                                    : "auto",
                                            }}
                                        >
                                            <span
                                                style={{
                                                    textDecoration: "underline",
                                                }}
                                            >
                                                {" "}
                                                {window.location.pathname ===
                                                "/hrm/timekeeping/wage/table"
                                                    ? t("common.import")
                                                    : t("common.add")}
                                            </span>
                                        </Button>
                                    )}
                                </>
                            }
                        />
                    </div>
                </div>
            )}
        </>
    );
}

Nodata.propTypes = {
    loading: PropTypes.bool,
    tabKey: PropTypes.string,
};

export default Nodata;
